import { byStartTime } from "./sort";
import {
    includesPlatform,
    includesType,
    includesTeamCA,
    includesMedal,
    isType,
    includesOlympics,
    filterScheduleData,
} from "./filters";
import { formatScheduleItem } from "./format";
import { SCHEDULE_FORMATTED_MAP } from "../../constants/sports";
import { startNow } from "./utils";

const includesTeamCAMedal = (arr) => includesTeamCA(arr) && includesMedal(arr);
const matchesType = (type) => (obj) =>
    isType(obj) && obj.typ.some((str) => str.includes(type));
const SORT_BY = {
    START_TIME: (scheduleData) => scheduleData.sort(byStartTime),
};
const getSportSchedule = (
    { platform, sport, event, isTeamCanada, isMedal },
    scheduleData,
    sortBy
) => {
    if (!Array.isArray(scheduleData))
        throw new Error("scheduleData must be an array");

    if (typeof sortBy === "function") {
        scheduleData = sortBy(scheduleData);
    }

    if (isTeamCanada || isMedal) {
        const filter =
            (isTeamCanada && isMedal && includesTeamCAMedal) ||
            (isTeamCanada && includesTeamCA) ||
            includesMedal;
        scheduleData = scheduleData.filter(includesOlympics(filter));
    }

    const checkList = [
        [platform, includesPlatform(platform)],
        [event, matchesType(event)],
        [sport, includesType(sport)],
    ].reduce((acc, [key, val]) => {
        if (key) {
            acc.push(val);
        }
        return acc;
    }, []);

    const dataToReturn = scheduleData.reduce((accumulator, item) => {
        if (checkList.every((it) => it(item))) {
            const formattedItem = formatScheduleItem(item);
            if (formattedItem) accumulator.push(formattedItem);
        }
        return accumulator;
    }, []);

    return dataToReturn;
};

const createFilteredScheduleList = (
    filterBar = {},
    filter = {},
    scheduleList = [],
    zone
) => {
    const { type, ...noTypefilterBar } = filterBar;
    const extraFilter = SCHEDULE_FORMATTED_MAP[type]
        ? (obj) => {
              return (
                  startNow(zone)(obj) &&
                  includesType(SCHEDULE_FORMATTED_MAP[type])(obj)
              );
          }
        : startNow(zone);

    return filterScheduleData(
        scheduleList,
        {
            ...filter,
            ...noTypefilterBar,
        },
        extraFilter
    ).sort(byStartTime);
};

export { getSportSchedule as default, SORT_BY, createFilteredScheduleList };
